import type { PromptRun } from '../services/api';

export const formatRunSegmentationLabel = (
  run: PromptRun | null | undefined,
  mediaType?: string | null,
): string | null => {
  if (!run) return null;
  const mode = mediaType === 'audio' ? run.audio_segmentation_type : run.video_segmentation_type;
  if (!mode) return null;
  const duration = mediaType === 'audio' ? run.audio_segment_duration : run.video_segment_duration;
  if (mode === 'content_aware') return 'Content Aware';
  if (mode === 'fixed') return duration ? `Fixed (${duration}s)` : 'Fixed';
  return mode.replace(/_/g, ' ').replace(/^\w/, (letter) => letter.toUpperCase());
};
